export default "__VITE_ASSET__Dvqcl_7J__"